export default __webpack_public_path__ + "static/ondemand-2e9f7f7a859f73085806e481e9531429.webp";